import { Box, CircularProgress, IconButton, Popover, Stack, Tooltip, Typography } from '@mui/material';
import React from 'react';
import { DialogPromptListenSpeakNoGrade } from '../../api/DialogPromptApi';
import ChatBubble from '../ChatBubble';
import WordPinyin from '../WordPinyin';

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'; // outline rounded doesn't exist?
import AddSelfStudyBlueIcon from '../../asset/icon-add-self-study-blue.png';
import MicrophoneBlueIcon from '../../asset/icon-microphone-blue.png';
import AudioWaveIcon from '../../asset/icons8-audio-wave.gif';

import { useHistory, useLocation } from 'react-router-dom';
import { useAudioRecorder } from '../../AudioRecorder';
import { AudioApi } from '../../api/AudioApi';
import { ISentenceScore, ScoreApi } from '../../api/ScoreApi';
import AppBarContext from '../../context/AppBarContext';
import { useAudioPlayer } from '../../context/AudioPlayerContext';
import DialogPromptFooterContext from '../../context/DialogPromptFooterContext';
import { scrollElementIntoViewWithFallback } from '../../util/scrollUtils';
import AddSentenceDialog from '../AddSentenceDialog';
import { handleErrorMessage } from '../ErrorDialog';
import { TeacherAudioActions, getSelectedTeacherSpeakerRole } from '../TeacherAudioReportButton';
import { getAudioByText } from './DialogPromptComponent';

interface DialogPromptListenSpeakNoGradeComponentProps {
    dialogPrompt: DialogPromptListenSpeakNoGrade;
    setDialogPromptComplete: (dialogPromptId: number) => void;
    showAvatar?: boolean;
    chatBubbleContainerRef: React.RefObject<HTMLDivElement>;
    isSettings?: boolean;
}

const DialogPromptListenSpeakNoGradeComponent: React.FC<DialogPromptListenSpeakNoGradeComponentProps> = ({ dialogPrompt, setDialogPromptComplete, showAvatar = true, chatBubbleContainerRef }) => {

    const { setErrorMessage } = React.useContext(AppBarContext)
    const history = useHistory();
    const location = useLocation();

    const { playAudio } = useAudioPlayer();

    const { setRightNavigationList, setActionList, clearFooterList } = React.useContext(DialogPromptFooterContext)

    const [isScoring, setIsScoring] = React.useState(false);

    const [sentenceScore, setSentenceScore] = React.useState<ISentenceScore | null>(null);

    const [chatBubbleSentenceScoreDone, setChatBubbleSentenceScoreDone] = React.useState<boolean>(false);

    const [chatBubbleDone, setChatBubbleDone] = React.useState(false);
    const [chatBubbleContinueDone, setChatBubbleContinueDone] = React.useState(false);

    const storedLearnWithCharacter = localStorage.getItem('learnWithCharacter');
    const learnWithCharacter = storedLearnWithCharacter ? JSON.parse(storedLearnWithCharacter) : false;

    const wordPinyinRef = React.useRef<HTMLDivElement | null>(null);

    React.useEffect(() => {
        if (!chatBubbleDone || !wordPinyinRef.current) return;
        const observer = new MutationObserver(() => {
            if (wordPinyinRef.current) {
                scrollElementIntoViewWithFallback(wordPinyinRef.current);
                observer.disconnect(); // only do it once
            }
        });
        observer.observe(wordPinyinRef.current, {
            childList: true,
            subtree: true,
        });
        return () => observer.disconnect(); // clean up if component unmounts
    }, [chatBubbleDone]);

    const handleSpeakerClick = () => {
        const audioPromise = AudioApi.getTeacherSentence(dialogPrompt.sentence_id)

        audioPromise
            .then(response => {
                // check if the response was successful
                if (response.status >= 300) {
                    throw new Error('Getting male audio was not ok statuscode=' + response.status + " " + response.statusText);
                }
                return response.data;
            })
            .then(blob => {
                playAudio(blob)
                // create a new Audio object and set the source to the blob URL
                // const audio = new Audio(URL.createObjectURL(blob));
                // audio.play();
            })
            .catch(err => {
                handleErrorMessage(err, setErrorMessage, history, location);
            })
    };

    // const startRecording = () => {
    //     navigator.mediaDevices.getUserMedia({ audio: true })
    //         .then((stream) => {
    //             // console.log("startRecording() 1")
    //             mediaRecorderRef.current = new MediaRecorder(stream);
    //             mediaRecorderRef.current.addEventListener('dataavailable', handleAudioDataAvailable);
    //             mediaRecorderRef.current.addEventListener('stop', handleAudioDone);

    //             mediaRecorderRef.current.start();

    //             setIsRecording(true);
    //             // console.log("startRecording() 2")
    //         })
    //         .catch(err => {
    //             handleErrorMessage(err, setErrorMessage, history, location);
    //         });
    // };
    // const stopRecording = () => {
    //     if (mediaRecorderRef.current) {
    //         // console.log("stopRecording() 1")
    //         mediaRecorderRef.current.stop();
    //         mediaRecorderRef.current.removeEventListener('dataavailable', handleAudioDataAvailable);
    //         mediaRecorderRef.current.removeEventListener('stop', handleAudioDone);
    //         // console.log("stopRecording() 2")
    //     }

    //     setIsRecording(false);
    // };

    // const handleAudioDataAvailable = (event: BlobEvent) => {
    //     // console.log("handleAudioDataAvailable() 1")
    //     if (event.data.size > 0) {
    //         // console.log("event.data.size > 0")
    //         audioData = event.data;
    //     }
    // };

    // const handleAudioDone = () => {
    //     // console.log("handleAudioDone() 1")
    //     if (audioData) {
    //         // console.log("handleAudioDone() has audio data 1")
    //         setIsScoring(true)
    //         const formData = new FormData();
    //         formData.append('audio', audioData);

    //         ScoreApi.getScore(dialogPrompt.sentence_id, formData)
    //             .then(response => {
    //                 setIsScoring(false)
    //                 // check if the response was successful
    //                 if (response.status >= 300) {
    //                     throw new Error('Scoring audio was not ok statuscode=' + response.status + " " + response.statusText);
    //                 }
    //                 return response.data;
    //             })
    //             .then(responseJson => {
    //                 responseJson.audioData = audioData;
    //                 setSentenceScore(responseJson);
    //             })
    //             .catch(err => {
    //                 handleErrorMessage(err, setErrorMessage, history, location);
    //             })
    //     }
    // }

    const onStop = React.useCallback((audioData: Blob) => {
        setIsScoring(true)
        const formData = new FormData();
        formData.append('audio', audioData);

        ScoreApi.getScore(dialogPrompt.sentence_id, formData)
            .then(response => {
                setIsScoring(false)
                if (response.status >= 300) {
                    throw new Error('Scoring audio was not ok statuscode=' + response.status + " " + response.statusText);
                }
                return response.data;
            })
            .then(responseJson => {
                responseJson.audioData = audioData;
                setSentenceScore(responseJson);
            })
            .catch(err => {
                handleErrorMessage(err, setErrorMessage, history, location);
            })
    }, [dialogPrompt.sentence_id, setErrorMessage, history, location]);
    const { startRecording, stopRecording, isRecording } = useAudioRecorder({ setErrorMessage, onStop });

    const [infoAnchorEl, setInfoAnchorEl] = React.useState<null | HTMLElement>(null);
    const infoOpen = Boolean(infoAnchorEl);

    const handleInfoClick = (event: React.MouseEvent<HTMLElement>) => {
        setInfoAnchorEl(event.currentTarget);
    };

    const handleInfoClose = () => {
        setInfoAnchorEl(null);
    };

    const wordAudioReportContext = React.useMemo(() => ({
        sentenceId: dialogPrompt.sentence_id,
        dialogPromptId: dialogPrompt.id,
        textToSpeechSpeakerId: getSelectedTeacherSpeakerRole(),
        audioText: dialogPrompt.new_word,
        audioRole: 'listen_speak_no_grade_word_card',
    }), [dialogPrompt.id, dialogPrompt.new_word, dialogPrompt.sentence_id]);

    const [addSentenceDialogOpen, setAddSentenceDialogOpen] = React.useState(false);
    const [, setAddSentenceSuccessMessage] = React.useState('');

    const handleAddSentenceClick = () => {
        setAddSentenceDialogOpen(true);
    };


    const handleClose = () => {
        setAddSentenceDialogOpen(false);
        setAddSentenceSuccessMessage('')
    };
    React.useEffect(() => {
        if (chatBubbleDone && sentenceScore == null) {
            setRightNavigationList([
                <Tooltip title="Add to Pronunciation" arrow>
                    <IconButton aria-label="Add to Pronunciation" onClick={handleAddSentenceClick} sx={{ alignSelf: 'center' }}>
                        <img src={AddSelfStudyBlueIcon} alt="" style={{ height: '100%', width: 'auto', maxHeight: '24px' }} />
                    </IconButton>
                </Tooltip>
            ])
            setActionList([
                <IconButton aria-label={isRecording ? "Stop recording" : "Record"} onClick={isRecording ? stopRecording : startRecording}>
                    {isRecording ? <img src={AudioWaveIcon} alt="Recording" style={{ height: '100%', width: 'auto', maxHeight: '36px' }} />
                        : isScoring ? <CircularProgress size={24} sx={{ height: '100%', width: 'auto', maxHeight: '36px' }} />
                            : <img src={MicrophoneBlueIcon} alt="" style={{ height: '100%', width: 'auto', maxHeight: '36px' }} />}
                </IconButton>
            ])
        } else if (chatBubbleDone && sentenceScore != null) {
            clearFooterList()
        }
    }, [sentenceScore, isRecording, isScoring, chatBubbleDone, clearFooterList, setActionList, setRightNavigationList, startRecording, stopRecording]);

    const [promptAudio, setPromptAudio] = React.useState<Blob | null | undefined>(undefined);
    const [yesResponseAudio, setYesResponseAudio] = React.useState<Blob | null | undefined>(undefined);

    React.useEffect(() => {
        clearFooterList()
        getAudioByText(history, setErrorMessage, dialogPrompt.prompt, setPromptAudio)
        getAudioByText(history, setErrorMessage, dialogPrompt.yes_response, setYesResponseAudio)
    }, [clearFooterList, dialogPrompt.prompt, dialogPrompt.yes_response, history, setErrorMessage]);

    React.useEffect(() => {
        if (chatBubbleContainerRef.current) {
            scrollElementIntoViewWithFallback(chatBubbleContainerRef.current);
        }
    }, [sentenceScore, chatBubbleContainerRef]);


    React.useEffect(() => {
        if (chatBubbleContinueDone) {
            setDialogPromptComplete(dialogPrompt.id)
        }
    }, [chatBubbleContinueDone, dialogPrompt.id, setDialogPromptComplete])

    return (
        <Stack>
            <ChatBubble
                isTeacher={dialogPrompt.is_teacher}
                message={dialogPrompt.prompt}
                messageAudio={promptAudio ? promptAudio : null}
                showAvatar={showAvatar}
                chatBubbleContainerRef={chatBubbleContainerRef}
                setChatBubbleDone={setChatBubbleDone}
                dialogPromptId={dialogPrompt.id}
                audioRole="prompt"
            />

            {chatBubbleDone && (
                <Box className="border-dark"
                    sx={{
                        display: 'inline-flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',  // Ensures inner content is centered
                        width: 'fit-content',  // Keeps width only as large as needed
                        margin: '0 auto',      // Centers the Box horizontally
                        pb: 1, mb: 2,
                        maxWidth: '90%'
                    }}
                >
                    <Stack ref={wordPinyinRef} direction="row" alignItems="center" justifyContent="center" flexWrap="wrap" sx={{ pl: 2, pr: 3, display: 'inline-flex' }}>
                        <TeacherAudioActions
                            context={wordAudioReportContext}
                            onPlay={handleSpeakerClick}
                            speakerAriaLabel="Play word audio"
                        />
                        <WordPinyin
                            text={dialogPrompt.new_word}
                            pinyinList={dialogPrompt.new_word_pinyin}
                            showCharacter={learnWithCharacter}
                        />
                        {dialogPrompt.new_word_info_text && (<>
                            <IconButton aria-label="Show word info" onClick={handleInfoClick}>
                                <InfoOutlinedIcon sx={{
                                    width: 30,          // bigger width
                                    height: 30,         // bigger height
                                    color: '#0062FF',
                                }} />
                            </IconButton>
                            <Popover
                                open={infoOpen}
                                anchorEl={infoAnchorEl}
                                onClose={handleInfoClose}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'left',
                                }}
                            >
                                <Box sx={{ p: 2, maxWidth: '300px' }}>
                                    <Typography variant="body2">{dialogPrompt.new_word_info_text}</Typography>
                                </Box>
                            </Popover>
                        </>)}
                    </Stack>
                </Box>
            )}

            {sentenceScore != null && (
                <>
                    <ChatBubble
                        isTeacher={!dialogPrompt.is_teacher}
                        message={sentenceScore.text}
                        messageAudio={null}
                        sentenceScore={sentenceScore}
                        showAvatar={showAvatar}
                        chatBubbleContainerRef={chatBubbleContainerRef}
                        setChatBubbleDone={setChatBubbleSentenceScoreDone}
                    />
                    {chatBubbleSentenceScoreDone && (
                        <ChatBubble
                            isTeacher={dialogPrompt.is_teacher}
                            message={dialogPrompt.yes_response}
                            messageAudio={yesResponseAudio ? yesResponseAudio : null}
                            showAvatar={showAvatar}
                            chatBubbleContainerRef={chatBubbleContainerRef}
                            dialogPromptId={dialogPrompt.id}
                            audioRole="yes_response"
                            setChatBubbleDone={setChatBubbleContinueDone}
                        />
                    )}
                </>
            )}
            {/* Add Sentence Confirmation Dialog */}
            <AddSentenceDialog
                open={addSentenceDialogOpen}
                sentence={{ text: dialogPrompt.new_word, id: dialogPrompt.sentence_id }}
                onClose={handleClose}
            />

        </Stack>
    );
};

export default DialogPromptListenSpeakNoGradeComponent;
